import { AUXILIARY_WA_STATUS } from 'common/ActivityChip/const';

export const getAuxiliaryActivityForDelete = (payload) => {
	if (
		payload.status === AUXILIARY_WA_STATUS.actual ||
		payload.status === AUXILIARY_WA_STATUS.rejected
	) {
		return { cannotCancelAuxiliaryWA: true, id: null, version: null };
	}
	return {
		id: payload.firstWorkAssignmentId,
		version: Number(payload.firstWorkAssignmentVersion),
		cannotCancelAuxiliaryWA: false,
	};
};
